import * as React from 'react';
import { generateClassName } from '../utils';

interface Props {
  title: React.ReactNode;
  dim?: boolean;
  small?: boolean;
  subtitleChild?: React.ReactNode;
}

export const ThumbsGrid: React.FunctionComponent<Props> = props => {
  const { title, dim, small, children, subtitleChild } = props;
  return (
    <div className={generateClassName('thumbs-grid', { dim, small })}>
      <h1>{title}</h1>
      {subtitleChild}
      <div className="thumbs-grid-container">{children}</div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ThumbsGrid.tsx